/* @flow */

import TagManager from 'react-gtm-module';
import type { TagManagerArgs } from 'react-gtm-module';

const gtmId = process.env.REACT_APP_GOOGLE_TAG_MANAGER;

const gtmArgs: TagManagerArgs = {
  gtmId,
};

const init = () => {
  if (gtmId) {
    TagManager.initialize(gtmArgs);
  }
};

export default init;
